module.exports = __webpack_public_path__ + "img/thumbnail.f9231790.png";